import axios from '../../utils/axios2';

export default {

    namespaced: true,

    state: {
        roles: null,
        role: null
    },

    mutations: {
        setRoles(state, payload) {
            state.roles = payload;
        },
        setRole(state, payload) {
            state.role = payload;
        }
    },

    actions: {
        fetchRoles({commit, rootState}) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `roles`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit("setRoles", response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
            });
        },
        fetchRole({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `roles/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit("setRole", response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        },
        storeRole({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `roles`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        },
        updateRole({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `roles/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        },
        removeRole({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `roles/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        }
    }

}